// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FXBqbLQMB6LLQkb1n6_J{cursor:pointer;margin-top:8px;margin-bottom:10px}`, "",{"version":3,"sources":["webpack://./src/commun/composants/AppIconHome/AppIconHome.scss"],"names":[],"mappings":"AAEA,sBACE,cAAA,CACA,cAAA,CACA,kBAAA","sourcesContent":["@use \"src/css/global.scss\";\n\n.iconFERGE {\n  cursor: pointer;\n  margin-top: 8px;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconFERGE": `FXBqbLQMB6LLQkb1n6_J`
};
export default ___CSS_LOADER_EXPORT___;
